import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-music-list-simmer',
  templateUrl: './music-list-simmer.component.html',
  styleUrls: ['./music-list-simmer.component.css']
})
export class MusicListSimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
